export const sheets_en = {
  crm_edit_contact: "Edit contact",
  create_row_above: "Create contact above",
  create_row_below: "Create contact below",
  crm_add_enrichment: "Add enrichment",
  crm_customize_view: "Customize view",
  text: "Text",
  number: "Number",
  filter_on_this_column: "Filter on this column",
  hide: "Hide",
  quick_action: "Quick Actions",
  crm_auto_sync: "Auto-sync",
  auto_sync_drawer_title: "Auto-sync settings",
  crm_segmented_filters: "Segment Filters",
  segmented_filters_drawer_title: "Segments",
  new_segmented_view: "New segment view",
  add_condition: "Add condition",
  sorts: "Sorts",
  add_sort: "Add sort",
  save_state_default: "Autosave",
  save_state_saved: "All changes saved",
  save_state_saving: "Saving changes…",
  save_state_not_saved: "Changes not saved",
  save_state_offline: "Offline",

  limited_selection_select_rows_from: "Select rows from",
  selected_count: "{count} selected",

  crm_column_visibility_dialog_title: "Customized View",
  crm_column_visibility_dialog_desc:
    "Choose the data fields you want to display in this table.",
  crm_column_visibility_dialog_tips:
    "Don’t see the property you’re looking for? ",
  crm_column_visibility_dialog_available_fields: "Available Fields",
  crm_column_visibility_dialog_no_fields_title: "No fields available",

  crm_column_visibility_dialog_no_fields_desc:
    "There are no additional fields to add right now. Try adding new properties or enrichment fields to expand your table options.",

  crm_column_visibility_dialog_fields_order:
    "Selected Fields (Drag to reorder)",

  sheets: "Sheets",
  sheets_description:
    "Manage your contacts and companies in one organized workspace.",

  crm_delete_column_warning_dialog_title: 'Delete Column "{name}"',
  crm_delete_column_warning_dialog_para1: "You’re about to delete this column.",
  crm_delete_column_warning_dialog_para2:
    "This action cannot be undone. Please confirm if you want to proceed with deleting this column.",

  crm_delete_row_warning_dialog_title: "Delete Record",
  crm_delete_row_warning_dialog_para1: "You’re about to delete this record.",
  crm_delete_row_warning_dialog_para2:
    "This action cannot be undone. Please confirm if you want to proceed with deleting this record.",

  // Sheet capability popover
  sheet_type_autofill: "Auto-fill sheet",
  sheet_capability_title: "capabilities",
  sheet_capability_contact_enrichment: "Contact enrichment",
  sheet_capability_autofill_rules: "Auto-fill with rules",
  sheet_capability_autosync_sequences: "Auto-sync to sequences",
  sheet_capability_manual_add_import: "Manual add & import",
  sheet_edit_description: "Edit description",
  sheet_rename: "Rename sheet",
  sheet_duplicate: "Duplicate sheet",
  sheet_delete: "Delete sheet",

  sheets_loading_contacts: "Loading contacts…",
  sheets_contacts_error: "Unable to load this Sheet.",
  sheets_retry: "Retry",
  sheets_empty_contacts: "This Sheet has no contacts yet.",
  sheets_loading_list: "Loading Sheets…",
  sheets_list_error: "Unable to load Sheets.",
  sheets_empty_list: "No Sheets are available.",
  sheets_loading_schema: "Loading Sheet fields…",
  sheets_schema_error: "Unable to load Sheet fields.",
  sheets_loading_configuration: "Loading Sheet settings…",
  sheets_configuration_error: "Unable to load this Sheet's settings.",
  sheets_new_sheet_name: "New Sheet",
};

export const sheets_zhCn = {
  sheets_loading_contacts: "正在加载联系人…",
  sheets_contacts_error: "无法加载此工作表。",
  sheets_retry: "重试",
  sheets_empty_contacts: "此工作表中暂无联系人。",
  sheets_loading_list: "正在加载工作表…",
  sheets_list_error: "无法加载工作表。",
  sheets_empty_list: "暂无可用工作表。",
  sheets_loading_schema: "正在加载工作表字段…",
  sheets_schema_error: "无法加载工作表字段。",
  sheets_loading_configuration: "正在加载工作表设置…",
  sheets_configuration_error: "无法加载此工作表的设置。",
  sheets_new_sheet_name: "新建工作表",
};

export const sheets_zhTw = {
  sheets_loading_contacts: "正在載入聯絡人…",
  sheets_contacts_error: "無法載入此工作表。",
  sheets_retry: "重試",
  sheets_empty_contacts: "此工作表中尚無聯絡人。",
  sheets_loading_list: "正在載入工作表…",
  sheets_list_error: "無法載入工作表。",
  sheets_empty_list: "目前沒有可用的工作表。",
  sheets_loading_schema: "正在載入工作表欄位…",
  sheets_schema_error: "無法載入工作表欄位。",
  sheets_loading_configuration: "正在載入工作表設定…",
  sheets_configuration_error: "無法載入此工作表的設定。",
  sheets_new_sheet_name: "新增工作表",
};

export const sheets_ja = {
  sheets_loading_contacts: "連絡先を読み込んでいます…",
  sheets_contacts_error: "このシートを読み込めません。",
  sheets_retry: "再試行",
  sheets_empty_contacts: "このシートにはまだ連絡先がありません。",
  sheets_loading_list: "シートを読み込んでいます…",
  sheets_list_error: "シートを読み込めません。",
  sheets_empty_list: "利用できるシートがありません。",
  sheets_loading_schema: "シートのフィールドを読み込んでいます…",
  sheets_schema_error: "シートのフィールドを読み込めません。",
  sheets_loading_configuration: "シート設定を読み込んでいます…",
  sheets_configuration_error: "このシートの設定を読み込めません。",
  sheets_new_sheet_name: "新しいシート",
};

export const sheets_hi = {
  sheets_loading_contacts: "संपर्क लोड हो रहे हैं…",
  sheets_contacts_error: "यह शीट लोड नहीं हो सकी।",
  sheets_retry: "पुनः प्रयास करें",
  sheets_empty_contacts: "इस शीट में अभी कोई संपर्क नहीं है।",
  sheets_loading_list: "शीट लोड हो रही हैं…",
  sheets_list_error: "शीट लोड नहीं हो सकीं।",
  sheets_empty_list: "कोई शीट उपलब्ध नहीं है।",
  sheets_loading_schema: "शीट फ़ील्ड लोड हो रहे हैं…",
  sheets_schema_error: "शीट फ़ील्ड लोड नहीं हो सके।",
  sheets_loading_configuration: "शीट सेटिंग लोड हो रही हैं…",
  sheets_configuration_error: "इस शीट की सेटिंग लोड नहीं हो सकीं।",
  sheets_new_sheet_name: "नई शीट",
};

export const sheets_ko = {
  sheets_loading_contacts: "연락처를 불러오는 중…",
  sheets_contacts_error: "이 시트를 불러올 수 없습니다.",
  sheets_retry: "다시 시도",
  sheets_empty_contacts: "이 시트에는 아직 연락처가 없습니다.",
  sheets_loading_list: "시트를 불러오는 중…",
  sheets_list_error: "시트를 불러올 수 없습니다.",
  sheets_empty_list: "사용 가능한 시트가 없습니다.",
  sheets_loading_schema: "시트 필드를 불러오는 중…",
  sheets_schema_error: "시트 필드를 불러올 수 없습니다.",
  sheets_loading_configuration: "시트 설정을 불러오는 중…",
  sheets_configuration_error: "이 시트의 설정을 불러올 수 없습니다.",
  sheets_new_sheet_name: "새 시트",
};
